import React, { Component } from 'react';
import TrackToggleButton from 'components/mix/TrackToggleButton.js';
import TrackMuteButton from 'components/mix/TrackMuteButton.js';
import { connect } from "react-redux";

class GroupMuteButton extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isGroupMuted() {
        return this.props.group.muted;
    }

    onGroupMuteClicked() {
        this.props.group.mute(!this.props.group.muted);
        this.setState(this.state);
    }

    onTrackMuteClicked() {
        let track = this.props.group.tracks[0];
        track.mute(!track.muted);
        this.setState(this.state);
    }

    isTrackMuted() {
        let track = this.props.group.tracks[0];
        return track.muted;
    }

    render() {
        if (this.props.group.tracks.length == 1) {
            return (
                <div className="group-top-buttons">
                  <div className="toggle-buttons-container">
                    <TrackToggleButton track={this.props.group.tracks[0]}/>
                  </div>
                  <div
                    onClick={() => this.onTrackMuteClicked()}
                    className={this.props.muted ? "muted group-mute-button" : "group-mute-button"}>
                  </div>
                </div>
            );
        }
        return (
            <div className="group-top-buttons">
              <div
                  onClick={() => this.onGroupMuteClicked()}
                  className={this.props.muted ? "muted small-group-mute-button" : "small-group-mute-button"}>
              </div>
              <div className="toggle-buttons-container">
                {this.props.group.tracks.map(
                track => <TrackToggleButton track={track}/>)}
              </div>
             <div className="track-mute-buttons-container">
                {this.props.group.tracks.map(
                track => <TrackMuteButton track={track}/>)}
              </div>
         
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let muted = state.tracks.groupMutes[props.group.groupNumber];
    if (props.group.tracks.length == 1) {
        muted = state.tracks.trackMutes[props.group.tracks[0].trackNumber];
    }
    return {
        muted: muted
    };
};

export default connect(mapStateToProps, null)(GroupMuteButton);
